module.exports = __webpack_public_path__ + "img/placeholder.a54a2313.png";